import React from "react";
import Banner from "../Pages/Banner";
import Header from "../header";
import Footer from "../Footer";
import ContactUsForm from './contactUsForm'

function ContactUs(props) {
    return (
        <div>
            <Header />
            <Banner checkPricing={true} btn_show={true} details = {"We have a global sales team available to assist you with a variety of topics, and to get you up-and-running with Detasad Cloud"} heading = {"CONTACT US"}/>
            <ContactUsForm/>
            <Footer />
        </div>
    );
}

export default ContactUs;
